import React from 'react';
import ContainerSectionTitle from 'components/content/shared/other/ContainerSectionTitle';
import AppLink from 'components/content/shared/links/AppLink';
import { deliveriesPageRoutes, invoicesPageRoutes, IRoute } from 'components/navigation/routes';
import { RouteId } from 'types/frontend_models/navigation/RouteId';
import { useHistory } from 'react-router-dom';



interface IProps
{
	orderId: number
	orderNumber: string | undefined
}

function OrderDetailLinks(props: IProps)
{

	const history = useHistory();

	function onRelatedDeliveriesClick()
	{
		// open deliveries page
		const route = deliveriesPageRoutes.find(r => r.routeId === RouteId.deliveriesOverview) as IRoute;
		let urlPath = encodeURI(`${route.path}?filters=orderNumber eq ${props.orderNumber}`);
		history.push(urlPath);
	}

	function onRelatedInvoicesClick()
	{
		const route = invoicesPageRoutes.find(r => r.routeId === RouteId.invoicesOverview) as IRoute;
		let urlPath = encodeURI(`${route.path}?filters=orderNumber eq ${props.orderNumber}`);
		history.push(urlPath);
	}

	return (
		<>
			<ContainerSectionTitle>Links</ContainerSectionTitle>
			<div>
				<AppLink className="mgr-35 pdy-5" onClick={onRelatedDeliveriesClick} href="">
					Related Deliveries
				</AppLink>
				<AppLink className="mgr-35 pdy-5" onClick={onRelatedInvoicesClick} href="">
					Related Invoices
				</AppLink>
			</div>
		</>
	);
};

export default OrderDetailLinks;